import * as React from 'react';
import { OnWhen } from '@cvent/carina/components/OnWhen';
import { Button } from '@cvent/carina/components/Button';
const discountIcon = require('../../../assets/icons/discount.svg');

import { toUSD } from '@weddingspot/ws-core-components';
import { Search } from '@weddingspot/ws-api-client';
import { FeatureFlagContext, FLAG_SRP_PRICE_VENUE_CTA } from '@weddingspot/ws-core-components';

const _styles = require('../venueCard.scss');

interface OldBottomRowProps {
    venue: Search.SearchResult;
    contactAvailable: boolean;
    handlePriceVenueClick: (e: React.SyntheticEvent) => void;
}

const OldBottomRow = (props: OldBottomRowProps) => {
    const { venue, contactAvailable, handlePriceVenueClick } = props;

    const { flagEnabled } = React.useContext(FeatureFlagContext);

    return (
        <div className={_styles.bottomRow}>
            <div className={_styles.priceAndCapacity}>
                {venue.discounts_available && <img className={_styles.discountIcon} src={discountIcon} alt='discount available' />}
                {!!venue.starting_at && !!venue.max_capacity && (
                    <div className={_styles.budgetRange} itemProp='priceRange'>
                        Starting at <b>{toUSD(venue.starting_at)}</b> for <b>{venue.max_capacity}</b> Guests
                    </div>
                )}
            </div>

            <div className={_styles.buttonContainer}>
                <div className={'onWhenM'}>
                    <OnWhen m={true} l={true} xl={true}>
                        <Button
                            text={contactAvailable ? 'Contact Venue' : venue.cta_button.label}
                            onClick={handlePriceVenueClick}
                            size='l'
                        />
                    </OnWhen>
                </div>
                <div className={'onWhenS'}>
                    <OnWhen s={true} m={true}>
                        <Button
                            appearance={flagEnabled(FLAG_SRP_PRICE_VENUE_CTA) ? 'filled' : undefined}
                            text={contactAvailable ? 'Contact Venue' : venue.cta_button.label}
                            onClick={handlePriceVenueClick}
                            size='l'
                        />
                    </OnWhen>
                </div>
            </div>
        </div>
    );
};

export default OldBottomRow;
